<template>
  <div class="field-editor-new" v-loading="initLoading">
    <template v-if="step === 0">
      <div class="field-editor-container">
        <baseStepForm :name.sync="formInfo.name" :type.sync="formInfo.type" />
      </div>
      <div class="field-editor-bottom-tools">
        <el-button @click="closeHandle">
          <span>取消</span>
        </el-button>
        <el-button type="primary" @click="showFormHandle">
          <span>下一步</span>
        </el-button>
      </div>
    </template>

    <template v-if="step === 1">
      <div class="field-editor-container" :style="{ padding: '0 20px' }">
        <el-form @submit.native.prevent label-width="100px" label-position="left">
          <el-form-item label="标签名称" required>
            <el-input maxlength="60" placeholder="请输入标签名称" v-model="formInfo.name" />
          </el-form-item>
          <el-form-item label="标签类型" required>
            <el-select
              popper-class="field-type-group-select"
              v-model="formInfo.type"
              :style="{ width: '100%' }"
              filterable
              @change="fieldTypeChange"
            >
              <el-option-group v-for="typeItem in typeList" :key="typeItem.key" :label="typeItem.label">
                <el-option
                  v-for="subTypeItem in typeItem.children"
                  :key="subTypeItem.type"
                  :label="subTypeItem.label"
                  :value="subTypeItem.type"
                >
                  <div class="select-option-text">
                    <div class="select-option-label">{{ subTypeItem.label }}</div>
                    <div class="select-option-tip">{{ subTypeItem.tip }}</div>
                  </div>
                </el-option>
              </el-option-group>
            </el-select>

            <div class="field-type-handle-tools">
              <el-button type="text" v-if="isDict" @click="dictEditorShow = true">
                <span>编辑标签分类</span>
              </el-button>
              <el-button type="text" v-if="isNormalNum" @click="numUnitEditorShow = true">
                <span>编辑计量单位</span>
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="关联分组" required>
            <el-select v-model="formInfo.groupRelationId" placeholder="请选择关联分组" :style="{ width: '100%' }">
              <el-option
                v-for="unitGroup in courseUnitGroups"
                :key="unitGroup.id"
                :value="unitGroup.id"
                :label="unitGroup.name"
              />
            </el-select>
            <div class="field-type-handle-tools">
              <el-button type="text" @click="groupEditorShow = true">
                <span>自定义分组</span>
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="批量标注规则">
            <el-select :style="{ width: '100%' }" v-model="formInfo.calculator_type" placeholder="请选择">
              <el-option :value="4" label="关键词抽取（智推）" />
              <el-option :value="1" label="关键词抽取（支持正则表达式）" />
              <el-option :value="2" label="Python 编程计算" />
              <el-option :value="3" label="简单计算公式" />
            </el-select>
          </el-form-item>
          <div class="form-field-rule-content" v-if="formInfo.calculator_type">
            <div v-show="formInfo.calculator_type === 1">
              <div class="form-field-rule-item">
                <div class="form-field-rule-title">
                  <span>标注段落</span>
                </div>
                <el-cascader
                  class="form-field-rule-option"
                  v-model="formInfo.paragraphArr"
                  :options="paragraphTree"
                  placeholder="全文"
                  clearable
                  :show-all-levels="false"
                  :props="{
                    expandTrigger: 'click',
                    multiple: true,
                    checkStrictly: true,
                    emitPath: false,
                    value: 'key',
                    label: 'value'
                  }"
                  @change="changeSelectParagraphHandle"
                />
              </div>
              <div class="form-field-rule-item">
                <div class="form-field-rule-title">
                  <span>包含关键词</span>
                  <span class="title-tip-text">(支持正则表达式)</span>
                </div>
                <el-input
                  class="form-field-rule-option"
                  placeholder="请输入"
                  v-model="formInfo.word"
                  :maxlength="800"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 6 }"
                  resize="none"
                  @keydown.enter.native="e => e.preventDefault()"
                />
              </div>
              <div class="form-field-rule-item">
                <div class="form-field-rule-title">
                  <span>排除关键词</span>
                  <span class="title-tip-text">(支持正则表达式)</span>
                </div>
                <el-input
                  class="form-field-rule-option"
                  placeholder="请输入"
                  v-model="formInfo.exclude_word"
                  :maxlength="800"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 6 }"
                  resize="none"
                  @keydown.enter.native="e => e.preventDefault()"
                />
              </div>
              <div class="form-field-rule-item">
                <div class="form-field-rule-title">
                  <span>排除关键词所在句</span>
                  <span class="title-tip-text">(支持正则表达式)</span>
                </div>
                <el-input
                  class="form-field-rule-option"
                  placeholder="请输入"
                  v-model="formInfo.exclude_sentence"
                  :maxlength="800"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 6 }"
                  resize="none"
                  @keydown.enter.native="e => e.preventDefault()"
                />
              </div>
              <div class="form-field-rule-tip">
                <div class="form-field-rule-tip-item">输入提示：</div>
                <div class="form-field-rule-tip-item">
                  <span>1、填写规则的符号需要用英文输入法的符号，中文输入法的符号将不生效。</span>
                </div>
                <div class="form-field-rule-tip-item">
                  <span>2、关键词之间用</span>
                  <el-tooltip content="点击复制">
                    <span class="symbol" v-copy:callback="handleCopied" v-copy="'|'">|</span>
                  </el-tooltip>
                  <span>竖线的符号代表“或”的搜索逻辑，（如：入户盗窃|入室盗窃）</span>
                </div>
                <div class="form-field-rule-tip-item">
                  <span>3、关键词之间加 </span>
                  <el-tooltip content="点击复制">
                    <span class="symbol" v-copy:callback="handleCopied" v-copy="'\\S*?'">\S*?</span>
                  </el-tooltip>
                  <span
                    >的符号，代表匹配关键词的最小范围(包含关键词本身)。如：盗窃\S*?次，在李某某盗窃3次、刘某某参与其中2次的句子中，匹配结果为：盗窃3次。</span
                  >
                </div>
                <div class="form-field-rule-tip-item">
                  <span>4、关键词之间加 </span>
                  <el-tooltip content="点击复制">
                    <span class="symbol" v-copy:callback="handleCopied" v-copy="'\\S*'">\S*</span>
                  </el-tooltip>
                  <span
                    >的符号，代表匹配关键词的最大范围(包含关键词本身)。如：盗窃\S*次，在李某某盗窃3次、刘某某参与其中2次的句子中，匹配结果为：盗窃3次、刘某某参与其中2次。</span
                  >
                </div>
                <div class="form-field-rule-tip-item">
                  <span>5、书写正则表达式的时候，可以用英文括号</span>
                  <el-tooltip content="点击复制">
                    <span class="symbol" v-copy:callback="handleCopied" v-copy="'()'">()</span>
                  </el-tooltip>
                  <span>将同一组的表达式括起来。如：(盗窃\S*?次)|(偷窃\S*?次)。</span>
                </div>
              </div>
            </div>
            <div v-show="formInfo.calculator_type === 2">
              <div class="ace-editor" ref="ace"></div>
            </div>
            <div v-show="formInfo.calculator_type === 3">
              <calculator-editor
                :defaultCode.sync="formInfo.calculator_code"
                :defaultColumns="courseDetail._source.fields"
                :currentField="fieldDetailUpd"
                :courseId="courseDetail._id"
                :fieldName="formInfo.name"
                :fieldType="formInfo.type"
              />
            </div>
            <div class="field-regexp-robot-content" v-show="formInfo.calculator_type === 4">
              <fieldRegexpRobot
                ref="fieldRegexpRobotRef"
                :courseId="courseDetail._id"
                :formInfo="formInfo"
                :defaultSelectTextArr="defaultSelectTextArr"
                @updDict="addTextToDictHandle"
                @change="val => (formInfo.regInfoArr = val)"
              />
            </div>
          </div>
        </el-form>
      </div>
      <div class="field-editor-bottom-tools">
        <el-button @click="closeHandle" :disabled="saveLoading">
          <span>取消</span>
        </el-button>
        <template v-if="couldSave">
          <el-button type="primary" plain :loading="saveLoading" @click="saveHandle({ runType: '' })">
            <span>保存</span>
          </el-button>
          <el-button
            type="primary"
            :disabled="runDisabled(formInfo)"
            :loading="saveLoading"
            @click="saveHandle({ runType: '追加' })"
            v-if="isCreate"
          >
            <span>保存并运行规则</span>
          </el-button>
          <el-dropdown
            :style="{ marginLeft: '10px' }"
            placement="top"
            @command="runType => saveHandle({ runType })"
            v-else
          >
            <el-button :disabled="runDisabled(formInfo)" type="primary" :loading="saveLoading">
              <span>保存并运行规则</span>
              <i :style="{ marginLeft: '4px' }" class="el-icon-caret-top"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="追加">
                <div class="auto-tag-btn">
                  <div class="auto-tag-title">保存并运行叠加规则</div>
                  <div class="auto-tag-tip">
                    <span
                      >指在原来规则的基础上，加上新增规则来清洗未标注的案件。（对预置标签进行叠加操作后，无法恢复初始化，请谨慎操作。）</span
                    >
                  </div>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="覆盖">
                <div class="auto-tag-btn">
                  <div class="auto-tag-title">保存并运行覆盖规则</div>
                  <div class="auto-tag-tip">
                    <span
                      >指以当前全新的规则重新清洗全部案件。（对预置标签进行覆盖操作后，无法恢复初始化，请谨慎操作。）</span
                    >
                  </div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </template>

    <dictEditorModal
      v-if="dictEditorShow"
      :show.sync="dictEditorShow"
      :dictClassifyValue="formInfo.dictClassifyValue"
      @change="updDictClassifyValue"
    />

    <unitEditorModal
      v-if="numUnitEditorShow"
      :show.sync="numUnitEditorShow"
      :numClassifyUnit="formInfo.numClassifyUnit"
      @change="val => (formInfo.numClassifyUnit = val)"
    />

    <groupEditorModal
      v-if="groupEditorShow"
      :show.sync="groupEditorShow"
      :courseId="courseDetail._id"
      @change="refreshUniGroup()"
    />
  </div>
</template>

<script>
import { services } from '@/service';
import {
  arrayToTree,
  formatColumnToFormInfo,
  transformColumnToSource,
  clearColumnInvalidAttr,
  checkFieldRun,
  initColumns,
  upgradeFieldForCourse,
  splitType
} from '@/lib/utils';
import baseStepForm from './components/baseStepForm.vue';
import dictEditorModal from './components/dictEditorModal.vue';
import unitEditorModal from './components/unitEditorModal.vue';
import calculatorEditor from '../fieldEditorComponents/calculatorEditor.vue';
import fieldRegexpRobot from './components/fieldRegexpRobot.vue';
import groupEditorModal from '@/views/dataCleaner/components/groupEditorModal/index.vue';

import ace from 'ace-builds';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/theme-monokai';
import eventBus from '@/lib/eventBus';

let aceEditor = null;

export default {
  components: { baseStepForm, dictEditorModal, unitEditorModal, calculatorEditor, fieldRegexpRobot, groupEditorModal },
  data() {
    return {
      initLoading: false,
      paragraphTree: [],
      saveLoading: false,
      typeList: services.labelRelation.getEntityRelationGroup(),
      step: 0,
      formInfo: {
        name: '',
        word: '',
        exclude_word: '',
        exclude_sentence: '',
        regInfoArr: [],
        type: '',
        calculator_type: '',
        paragraphArr: [],
        base_caseType: [],
        procedureType: [],
        dictClassifyValue: [],
        numClassifyUnit: [],
        code: '',
        calculator_code: '',
        groupRelationId: ''
      },
      dictEditorShow: false,
      numUnitEditorShow: false,
      defaultSelectTextArr: [],
      fieldDetailUpd: null,
      sysFieldUnitEnum: {},
      preSelectParagraphArrIds: [],
      courseUnitGroups: [],
      groupEditorShow: false
    };
  },
  props: {
    courseDetail: {
      type: Object,
      required: true
    },
    chartIndexId: {
      type: Number,
      default: -1
    },
    fieldDetail: {
      type: Object,
      default: () => null
    },
    fieldDefaultInfo: {
      type: Object,
      default: () => null
    },
    couldSave: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isCreate() {
      return !this.fieldDetailUpd;
    },
    isDict() {
      return this.formInfo.type === 'text_dict';
    },
    isNormalNum() {
      return this.formInfo.type.slice(0, 3) === 'num' && this.formInfo.type !== 'num_entity_sort';
    }
  },
  watch: {
    'formInfo.calculator_type'() {
      this.$store.dispatch('clearSelectionFetcher');

      if (this.initLoading) {
        return;
      }

      this.initSelectionFetcher();

      this.initAceEditor();
    }
  },
  beforeDestroy() {
    this.$store.dispatch('clearSelectionFetcher');
    this.$store.dispatch('updFieldEditorShow', false);
    this.destroyAceEditor();
  },
  created() {
    this.$store.dispatch('updFieldEditorShow', true);
    this.fieldDetailUpd = this.fieldDetail;
  },
  async mounted() {
    try {
      this.initLoading = true;
      const { byRecommend = false, selectText = '', paragraphKey = '' } = this.fieldDefaultInfo || {};
      if (this.fieldDetailUpd) {
        this.formInfo = {
          ...this.formInfo,
          ...formatColumnToFormInfo(this.fieldDetailUpd)
        };
        if (this.formInfo.type === 'text_dict') {
          await this.initDictClassifyValue(this.fieldDetailUpd._id);
        }
        this.preSelectParagraphArrIds = [...this.formInfo.paragraphArr];
      } else if (selectText.trim()) {
        this.formInfo.calculator_type = 4;
        this.defaultSelectTextArr = [{ selectText: selectText.trim(), paragraphKey }];
      }

      // 初始化段落及默认的数值单位表【提前请求缓存promise，内部组件用的时候就不用等加载】
      const [paragraphArr, sysFieldUnitEnum] = await Promise.all([
        services.labelRelation.getParagraph(this.courseDetail._id),
        services.courseware.getSysFieldUnit(),
        this.refreshUniGroup()
      ]);
      this.sysFieldUnitEnum = sysFieldUnitEnum;
      this.paragraphTree = arrayToTree(paragraphArr, { key: 'key', parentKey: 'levelId' }).filter(item => {
        return item.key !== 'para_content';
      });

      if (this.formInfo.name && this.formInfo.type) {
        this.step = 1;
      }

      if (!this.formInfo.groupRelationId && this.courseUnitGroups.length > 0) {
        this.formInfo.groupRelationId = this.courseUnitGroups[0].id;
      }

      if (byRecommend && this.fieldDetailUpd) {
        const result = await services.courseware.fetchRecommendSentence(this.courseDetail._id, this.fieldDetailUpd._id);
        this.formInfo.calculator_type = 4;
        this.$nextTick(() => {
          const fieldRegexpRobotRef = this.$refs.fieldRegexpRobotRef;
          if (fieldRegexpRobotRef) {
            result.forEach(o => {
              const text = (o._source.content || '').trim();
              if (!text) {
                return;
              }
              const idx = (this.formInfo.regInfoArr || []).findIndex(regInfoItem => regInfoItem.text === text);
              if (idx === -1) {
                fieldRegexpRobotRef.addTextHandle(text, o._source.paragraphId);
              }
            });
          }
        });
      }

      this.initSelectionFetcher();
      this.initAceEditor();
    } catch (err) {
      this.$error(err);
    } finally {
      this.initLoading = false;
    }
  },
  methods: {
    async refreshUniGroup() {
      this.courseUnitGroups = await services.courseware.getCourseUnitGroups(this.courseDetail._id);
      eventBus.$emit('changeCourseUnitGroups', {
        courseId: this.courseDetail._id,
        courseUnitGroups: this.courseUnitGroups
      });
    },
    changeSelectParagraphHandle(val) {
      const addNew = val.filter(id => !this.preSelectParagraphArrIds.includes(id));
      const allChildIds = [];
      this.paragraphTree.forEach(item => {
        if (addNew.includes(item.key)) {
          (item.children || []).forEach(subItem => allChildIds.push(subItem.key));
        }
      });

      this.formInfo.paragraphArr = [...new Set([...this.formInfo.paragraphArr, ...allChildIds])];
      this.preSelectParagraphArrIds = [...this.formInfo.paragraphArr];
    },
    initSelectionFetcher() {
      if (this.formInfo.calculator_type === 4) {
        this.$store.dispatch('initSelectionFetcher', (str, paragraphKey) => {
          const fieldRegexpRobotRef = this.$refs.fieldRegexpRobotRef;
          if (fieldRegexpRobotRef) {
            fieldRegexpRobotRef.addTextHandle(str, paragraphKey);
          }
        });
      }
    },
    initAceEditor() {
      if (this.formInfo.calculator_type === 2) {
        this.destroyAceEditor();

        this.$nextTick(() => {
          aceEditor = ace.edit(this.$refs.ace, {
            mode: 'ace/mode/python',
            theme: 'ace/theme/monokai',
            showPrintMargin: false
          });
          aceEditor.setValue(this.formInfo.code, 1);
          aceEditor.on('change', () => {
            this.formInfo.code = aceEditor.getValue();
          });
        });
      }
    },
    fieldTypeChange() {
      const fieldRegexpRobotRef = this.$refs.fieldRegexpRobotRef;
      if (fieldRegexpRobotRef) {
        fieldRegexpRobotRef.clearHandle();
      } else {
        this.formInfo.regInfoArr = [];
      }
      this.initNumUnitHandle();
    },
    destroyAceEditor() {
      if (aceEditor) {
        aceEditor.destroy();
        aceEditor = null;
      }
    },
    runDisabled(info) {
      const { pass } = checkFieldRun(info);
      if (pass) {
        return false;
      } else {
        return true;
      }
    },
    handleCopied(val) {
      if (val) {
        this.$message.success('复制成功');
      }
    },
    updDictClassifyValue(arr) {
      this.formInfo.dictClassifyValue = Object.freeze(arr);
    },
    addTextToDictHandle({ text, dictItem }) {
      text = (text || '').trim();
      if (!text) {
        return;
      }
      if (dictItem) {
        const arr = [...this.formInfo.dictClassifyValue];
        const idx = arr.findIndex(o => o.labelName === dictItem.labelName);
        if (idx !== -1) {
          const childrenArr = (arr[idx].children || '').split('|').filter(text => !!text);
          childrenArr.push(text);
          arr.splice(idx, 1, { ...arr[idx], children: childrenArr.join('|') });
          this.updDictClassifyValue(arr);
        }
      } else {
        const idx = this.formInfo.dictClassifyValue.findIndex(o => o.labelName === text);
        if (idx === -1) {
          this.updDictClassifyValue([...this.formInfo.dictClassifyValue, { labelName: text, children: '' }]);
        }
      }
    },
    async initDictClassifyValue(labelId) {
      try {
        const { data } = await services.caseRule.getFieldDictVal({
          labelId,
          keyword: '',
          courseId: '',
          size: 10000
        });
        this.updDictClassifyValue(data.dict_classify_value || []);
      } catch (err) {
        this.$error(err);
      }
    },
    async showFormHandle() {
      if (!this.formInfo.name) {
        this.$message.warning('请输入标签名称');
        return;
      }
      if (!this.formInfo.type) {
        this.$message.warning('请选择标签类型');
        return;
      }
      this.step = 1;
      this.formInfo.calculator_type = 4;
      this.initNumUnitHandle();

      await this.$nextTick();
      if (this.isDict) {
        this.defaultSelectTextArr.forEach(({ selectText }) => {
          this.formInfo.dictClassifyValue.push({ labelName: selectText, children: '' });
        });
      }
    },
    closeHandle() {
      this.$emit('close');
    },
    async saveHandle({ runType }) {
      if (!this.formInfo.name) {
        this.$message.warning('请输入标签名称');
        return;
      }
      if (!this.formInfo.groupRelationId) {
        this.$message.warning('请选择关联分组');
        return;
      }
      const formatResult = clearColumnInvalidAttr(this.formInfo);

      if (formatResult.errMsg) {
        this.$message.warning(formatResult.errMsg);
        return;
      }

      try {
        this.saveLoading = true;

        const userInfo = this.$store.getters.userInfo;
        let fieldSource = transformColumnToSource({
          info: formatResult.info,
          typeList: this.typeList
        });

        let newId = '';
        if (this.isCreate) {
          newId = `${userInfo.id}_${Date.now()}`;
          fieldSource = {
            ...fieldSource,
            ownerId: userInfo.id,
            coursewareId: this.courseDetail._id,
            parentId: '',
            field_name: newId,
            full_path: newId,
            full_name: fieldSource.chinese_name,
            groups: this.courseDetail._source.instrumentType,
            show: true,
            create_time: fieldSource.update_time
          };
          await services.courseware.addField(newId, fieldSource);
        } else {
          await services.courseware.updField(this.fieldDetailUpd._id, fieldSource);
          newId = this.fieldDetailUpd._id;
          fieldSource = { ...this.fieldDetailUpd, ...fieldSource };
        }

        const newFieldItem = initColumns([{ _id: newId, _source: fieldSource }])[0];

        const promises = [];

        if (this.isCreate) {
          promises.push(this.addToFields(newFieldItem));
        } else {
          promises.push(this.refreshCourseFields(newFieldItem));
          promises.push(this.transformNumFieldValue(newFieldItem));
        }

        if (runType) {
          promises.push(this.runLabelHandle(newFieldItem, runType));
        }

        await Promise.all(promises);

        if (runType) {
          this.$message.success('保存并运行规则成功');
          this.closeHandle();
        } else {
          this.$message.success('保存成功');
          this.fieldDetailUpd = newFieldItem;
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.saveLoading = false;
      }
    },
    async runLabelHandle(item, runType) {
      try {
        await services.caseRule.autuAddTag({
          courseId: this.courseDetail._id,
          courseTitle: this.courseDetail._source.title,
          dataSource: JSON.stringify({ query: [] }),
          fieldDetailArr: [item],
          runType
        });
      } catch (err) {
        this.$error(err);
      }
    },
    async addToFields(newFieldItem) {
      try {
        let newCourseSource = null;

        if (this.chartIndexId === -1) {
          newCourseSource = {
            ...this.courseDetail._source,
            fields: [...this.courseDetail._source.fields, newFieldItem]
          };
        } else {
          const charts = [...this.courseDetail._source.chart];
          const chartIdx = charts.findIndex(chartItem => chartItem.index_id === this.chartIndexId);
          const chartItem = charts[chartIdx];
          charts.splice(chartIdx, 1, {
            ...chartItem,
            fields: [...chartItem.fields, newFieldItem]
          });
          newCourseSource = {
            ...this.courseDetail._source,
            chart: charts
          };
        }

        await services.courseware.saveCourseware(this.courseDetail._id, newCourseSource);

        this.$emit('updCourseDetail', { ...this.courseDetail, _source: newCourseSource });
      } catch (err) {
        this.$error(err);
      }
    },
    async refreshCourseFields(newFieldItem) {
      try {
        if (this.fieldDefaultInfo && this.fieldDefaultInfo.byRecommend) {
          this.$emit('clearRecommend', this.fieldDetailUpd);
        }

        const newCourseSource = upgradeFieldForCourse(newFieldItem, this.courseDetail);

        await services.courseware.saveCourseware(this.courseDetail._id, newCourseSource);

        this.$emit('updCourseDetail', { ...this.courseDetail, _source: newCourseSource });
      } catch (err) {
        this.$error(err);
      }
    },
    async transformNumFieldValue(newFieldItem) {
      if (newFieldItem.type !== 'num' || this.fieldDetailUpd.type !== 'num') {
        return;
      }
      if (newFieldItem.numUnitDefault !== this.fieldDetailUpd.numUnitDefault) {
        await services.courseware.transformNumFieldValue(
          this.courseDetail._id,
          newFieldItem._id,
          this.fieldDetailUpd.numUnitDefault,
          newFieldItem.numUnitDefault
        );
      }
    },
    initNumUnitHandle() {
      if (this.formInfo.type.slice(0, 3) !== 'num') {
        return;
      }
      const { deputyFieldType } = splitType(this.formInfo.type);
      this.formInfo.numClassifyUnit = (this.sysFieldUnitEnum[deputyFieldType] || []).map(item => {
        return {
          unit: item.unit,
          reg: item.reg,
          transform: item.transform,
          default: item.default
        };
      });
    }
  }
};
</script>

<style lang="scss">
.field-type-group-select {
  .el-select-dropdown__wrap {
    max-height: 375px;
  }
  .el-select-dropdown__item {
    height: auto;
  }

  .select-option-text {
    font-size: 14px;
    line-height: 20px;
  }

  .select-option-tip {
    font-size: 12px;
    color: #9599a5;
    line-height: 17px;
    margin-bottom: 8px;
  }
}
</style>

<style lang="scss" scoped>
.auto-tag-btn {
  .auto-tag-title {
    font-size: 14px;
    line-height: 20px;
    color: #2c3443;
    padding: 5px 0 2px;
  }

  .auto-tag-tip {
    font-size: 12px;
    line-height: 17px;
    color: #77839e;
    padding: 0px 0 5px;
    width: 220px;
    font-weight: 200;
  }
}
.field-editor-new {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .field-editor-container {
    flex: 1;
    height: 0;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .field-editor-bottom-tools {
    text-align: right;
    margin: 10px 20px;
  }

  .ace-editor {
    height: 400px;
    width: 100%;
  }

  .form-field-rule-content {
    padding: 14px;
    overflow: hidden;
    background-color: #f8fafd;
    border: 1px solid #edf1f7;
    border-radius: 3px;
    margin-top: 14px;

    .form-field-rule-header {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      background-color: rgba(#d2d8e3, 0.2);
      width: calc(100% + 28px);
      margin-top: -1px;
      margin-bottom: 20px;
      margin-left: -14px;
      border-bottom: 1px solid #d2d8e3;

      .form-field-rule-header-item {
        text-align: center;
        width: 33.33%;
        cursor: pointer;
        padding: 4px 0;

        .header-item-title {
          font-size: 14px;
          color: rgba(#2c3443, 0.8);
          height: 20px;
          line-height: 20px;
        }
        .header-item-tip {
          font-size: 12px;
          color: rgba(#77839e, 0.7);
          height: 17px;
          line-height: 17px;
        }

        &.is-active {
          background-color: #fff;
          border-bottom: 0;
          border-right: 1px solid #d2d8e3;
          border-left: 1px solid #d2d8e3;
          margin-bottom: -1px;
        }

        &.is-disabled {
          cursor: not-allowed;
        }

        &.first-rule-child {
          border-left: 0 !important;
        }

        &.last-rule-child {
          border-right: 0 !important;
        }
      }
    }

    .form-field-rule-item {
      margin-bottom: 10px;

      .form-field-rule-title {
        font-size: 14px;
        color: rgba(#2c3443, 0.8);

        .title-tip-text {
          font-size: 12px;
          color: rgba(#2c3443, 0.5);
          margin-left: 4px;
        }
      }
      .form-field-rule-option {
        width: 100%;
        margin-top: 6px;
      }
    }

    .form-field-rule-tip {
      font-size: 12px;
      color: rgba(#77839e, 0.7);
      .form-field-rule-tip-item {
        line-height: 26px;

        .symbol {
          box-sizing: border-box;
          display: inline-block;
          min-width: 20px;
          height: 20px;
          color: #1991fb;
          background-color: #eaf6ff;
          text-align: center;
          line-height: 20px;
          padding: 0 5px;
          margin: 0 2px;
          cursor: pointer;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
